import {Box} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useParams, useRouteMatch} from 'react-router-dom';
import GenericHeader from '../../../../../../../components/generic-header/generic-header';
import {PlaylistForm} from '../../../../../../../components/playlist-form/playlist-form';
import {useOffice} from '../../../../../../../contexts/office/context';
import {CaregiverMode, ScreenPaths} from '../../../../../../../enums';
import {translations} from '../../../../../../../i18n/translations';

export default function PlaylistDetailsProfessionalCaregiverOfficeScreen({
  canWrite,
}: {
  canWrite: boolean;
}) {
  // Get params
  let {id, entityId, playlistId}: {id?: string; entityId: string; playlistId: string} = useParams();

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();
  const officeContext = useOffice();
  const {t} = useTranslation();

  const baseUrl = `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_DigitalInclusion}`;

  return (
    <>
      <GenericHeader
        isLoading={!officeContext.state.playlistForm}
        titleCrumbs={[
          {
            label: t(translations.office.professional_caregiver.tabs.digital_inclusion),
            link: baseUrl,
          },
          {
            label: t(translations.office.professional_caregiver.tabs.playlists),
            link: `${baseUrl}${ScreenPaths.ProfessionalCaregiver_DigitalInclusion_Playlists}`,
          },
          {
            label: officeContext.state.playlistForm?.name || '',
            link: `${baseUrl}${ScreenPaths.ProfessionalCaregiver_DigitalInclusion_Playlists}/${playlistId}`,
          },
          {
            label: t(translations.playlists.professional_caregiver.edit.tabs.details),
            link: url,
          },
        ]}
        leftColumn={null}
        rightColumn={null}
      />

      <Box className="listing-container">
        <Box className="listing-container-centered">
          <PlaylistForm
            caregiverMode={CaregiverMode.Professional}
            canWrite={canWrite}
            redirectUrl={url.replace(`/${id}`, '')}
            showExitButton={false}
            showPageTitle={false}
          />
        </Box>
      </Box>
    </>
  );
}
